import styled from '@emotion/styled';

import NextIcon from '@/assets/icons/icon_next_gray.svg';
import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';
import { hoverOpacity } from '@/utility/theme/animation';

export const Container = styled.div(() =>
  mq({
    width: '100%',
    maxWidth: '840px',
  }),
);

export const Wrapper = styled.div(() =>
  mq({
    width: '100%',
    backgroundColor: defaultTheme.background.white,
    padding: [
      defaultTheme.spacing.l,
      defaultTheme.spacing.l,
      '32px 64px',
      '32px 64px',
    ],
    margin: ['0 auto', '0 auto', 0, 0],
  }),
);

export const Initial = styled.p(() =>
  mq({
    fontSize: [
      defaultTheme.font.size.m,
      defaultTheme.font.size.m,
      defaultTheme.font.size.l,
      defaultTheme.font.size.l,
    ],
    fontWeight: 'bold',
    borderBottom: `1px solid ${defaultTheme.border.color.black}`,
    paddingBottom: defaultTheme.spacing.l,
  }),
);

export const TermList = styled.ul(() =>
  mq({
    '& > a, & > li': {
      display: 'block',
      fontSize: [
        defaultTheme.font.size.s,
        defaultTheme.font.size.s,
        defaultTheme.font.size.m,
        defaultTheme.font.size.m,
      ],
      borderBottom: `1px solid ${defaultTheme.border.color.mediumLightGray}`,
      padding: `${defaultTheme.spacing.l} 0`,
      ...hoverOpacity,
    },
  }),
);

export const ListItem = styled.li(() =>
  mq({
    display: 'grid',
    gridTemplateColumns: '1fr 8.21px',
    alignItems: 'center',
    lineHeight: defaultTheme.font.height.l,
    '&:after': {
      content: '""',
      display: 'block',
      height: '14px',
      width: '8.21px',
      backgroundImage: `url(${NextIcon})`,
      backgroundSize: 'contain',
      backgroundRepeat: 'no-repeat',
    },
  }),
);

export const ButtonWrapper = styled.div(() =>
  mq({
    display: 'flex',
    justifyContent: 'center',
    marginTop: defaultTheme.spacing.s,
  }),
);
